import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

import Info from '../images/info.svg';

const Container = styled.section`
  margin: 16px 16px;
  display: flex;
  color: #4a4a4a;

  @media(min-width: 1000px) {
    margin: 32px 8px;
    width: 100%;
  }
`;

const Icon = styled.img`
  height: 24px;
  object-fit: contain;
`;

const DetailBox = styled.div`
  margin-left: 16px;
  font-size: 16px;
  line-height: 1.5;
`;

const DetailText = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #4a4a4a;
  }

  strong {
    font-weight: bold;
  }
`;

const InformationDetail = ({ info }) => (
  <Container>
    <Icon src={Info} alt="INFO" />
    <DetailBox>
      <DetailText source={info} />
    </DetailBox>
  </Container>
);

InformationDetail.propTypes = {
  info: string.isRequired,
};

export default InformationDetail;
